import de from './de.json'
import en from './en.json'

const documentsLocales = { en, de }

export default documentsLocales
